import { Translatable, TransProp } from '@icc/shared/helpers';
import { Crank } from './crank';
import { Receiver } from './receiver';
import { CableExitType } from './cable-exit-type';

export class Drive {
    id: number;
    driveId: number;
    receiverDriveId?: number;
    receiver?: Receiver;
    @Translatable({ model: 'RollerShutterDrives', idField: 'driveId' })
    name: string;
    @Translatable({ model: 'RollerShutterDrives', idField: 'driveId' })
    shortName?: string;
    type: 'wired' | 'radio' | 'manual' | 'none' | 'hole';
    img: null | string;
    description: string;
    printCode: string;
    prices: DrivePrices[];
    shutterTypes: number[];
    shutterId: number;
    default: boolean;
    crank: Crank | null;
    linkedPrev: null | number;
    linkedNext: null | number;
    side: 'left' | 'right';
    driveOptionId: null | number;
    driveOptionChanged: boolean;
    hasDrive: boolean;
    hasCableHole: boolean;
    @TransProp()
    cableExitType: CableExitType | null;
    errors: {
        invalidLength: boolean;
        invalidDrive: boolean;
        invalidDriveConnection: boolean;
    };
}

export interface IccDrive {
    driveId: number;
    name: string;
    shortName?: string;
    type: 'wired' | 'radio' | 'manual' | 'none' | 'hole';
    img: null | string;
    description: string;
    printCode: string;
    prices: DrivePrices[];
    shutterTypes: number[];
}

export interface DrivePrices {
    id: number;
    name: string;
    extId?: string | null;
    area: number;
    lamella: number;
    maxWidth: number;
    maxHeight: number;
    engineSize: number;
    maxWeight: number;
    sizeRanges: {
        lamellaId: number | null;
        guideType: 'blind_guidance' | 'cord' | null;
        sizeRangeId: number | null;
    }[];
    override: boolean;
    iceDetection: boolean;
    weight: number;
    order?: number | null;
    /** Grupy typów produktów, dla których wariant jest dostępny (null = dostępny dla wszystkich) */
    shutterTypeGroupIds?: number[] | null;
}
